import axiosInstance from '../../Config/axiosConfig';

export const getChatList = async (search = '') => {
  try {
    const response = await axiosInstance.get(`/user/chat/getChatList?search=${search}`);
    
    if (!response.data.status) {
      throw new Error('Error fetching chat list', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getChat = async (chatId) => {
  try {
    const response = await axiosInstance.get(`/user/chat/getChat/${chatId}`);
    
    if (!response.data.status) {
      throw new Error('Error fetching chat', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const sendMessage = async (formData) => {
  try {
    const response = await axiosInstance.post('/user/chat/sendMessage', formData);
    
    if (!response.data.status) {
      throw new Error('Error sending message', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const reportUser = async (formData) => {
  try {
    const response = await axiosInstance.post('/user/report/create', formData);
    
    if (!response.data.status) {
      throw new Error('Error reporting user', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const blockUser = async (userId) => {
  try {
    const response = await axiosInstance.post('/user/block-user', {
      user_id: userId
    });
    
    if (!response.data.status) {
      throw new Error('Error blocking user', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const unmatchUser = async (userId) => {
  try {
    const response = await axiosInstance.get(`/user/unmatch/${userId}`);
    
    if (!response.data.status) {
      throw new Error('Error unmatching user', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getReminders = async (chatId, params = {}) => {
  try {
    const response = await axiosInstance.get(`/user/chats/${chatId}/reminders`, {
      params
    });
    
    if (!response.data.status) {
      throw new Error('Error fetching reminders', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const createReminder = async (reminderData) => {
  try {
    const response = await axiosInstance.post('/user/chats/reminders', reminderData);
    
    if (!response.data.status) {
      throw new Error('Error creating reminder', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getAutoReplies = async () => {
  try {
    const response = await axiosInstance.get('/user/auto-reply');
    
    if (!response.data.status) {
      throw new Error('Error fetching auto replies', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const saveAutoReply = async (message) => {
  try {
    const response = await axiosInstance.post('/user/auto-reply', {
      message: message
    });
    
    if (!response.data.status) {
      throw new Error('Error saving auto reply', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

